import usePublicVenueService from "@app-contexts/public/features/org-profile/data/services/usePublicVenueService";
import { convertPriceStringToInteger } from "@shared/modules/financials/utils/price-utils";
import { formatCountryToISOCode } from "@shared/utils/addresses/address-utils";
import type {
  StripePaymentMethodMessagingElement,
  StripePaymentMethodMessagingElementOptions,
} from "@stripe/stripe-js";
import { usePaymentManager } from "../../contexts/PaymentManagerContext";

import StripeElement from "../StripeElement/StripeElement.web";

/**
 * Dynamically displays messaging regarding payment methods.
 * The messaging is based on the available payment methods configured on Stripe dashboard
 */
function StripeMessagingElement({
  elementProps,
  onElementReady,
}: StripeMessagingElementProps) {
  const { manager } = usePaymentManager();

  const { useRetrieve } = usePublicVenueService();
  const { data } = useRetrieve(manager.basket?.paymentVenue, {
    options: {
      enabled: Boolean(manager.basket),
    },
  });

  if (!manager.basket || !data) return null;

  return (
    <StripeElement
      element="paymentMethodMessaging"
      elementProps={{
        amount: convertPriceStringToInteger(manager.basket.totalPrice),
        currency: data.currency,
        countryCode: formatCountryToISOCode(data.country),
        ...elementProps,
      }}
      onElementCreate={(_element) => {
        const element = _element as StripePaymentMethodMessagingElement;

        element.on("ready", () => {
          onElementReady?.();
        });
      }}
    />
  );
}

export default StripeMessagingElement;

type StripeMessagingElementProps = {
  elementProps: Partial<StripePaymentMethodMessagingElementOptions>;
  onElementReady?: () => void;
};
